import merge from 'lodash/merge';

import { BLACK, RED, LIGHT_GREY } from '../constants/colors';
import { getBradingInLocalStorage, getTeamLogoInLocalStorage } from './localStorage';

const DEFAULT_COLORS = {
  primary: BLACK,
  secondary: RED,
  tertiary: LIGHT_GREY,
};

export let COLOR_THEME = DEFAULT_COLORS;
export let LOGO_URL = '';

const CUSTOMER_THEME = getBradingInLocalStorage();
const CUSTOMER_LOGO_URL = getTeamLogoInLocalStorage();

if (CUSTOMER_THEME) {
  COLOR_THEME = merge(DEFAULT_COLORS, CUSTOMER_THEME);
}

if (CUSTOMER_LOGO_URL) {
  LOGO_URL = CUSTOMER_LOGO_URL;
}
